module.exports = __webpack_public_path__ + "static/media/parc-aquatique.ffd71d63.webp";